import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { serviceAi, serviceAi2 } from "@/lib/serviceImages";
import { t } from "@/lib/i18n";
import Reveal from "@/components/public/Reveal";

// A single tilted image card (mirrored by `dir`: -1 left, +1 right).
function TiltCard({ src, alt, dir }) {
  return (
    <div className="relative w-full h-[340px] sm:h-[440px] lg:h-[580px] group">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover rounded-[1.6rem] border border-white/10 shadow-2xl transition-transform duration-500 group-hover:rotate-0"
        style={{ transform: `rotate(${dir * -4}deg)` }}
      />
    </div>
  );
}

// Each service: centered text (index, title, desc, CTA) flanked by a unique, service-
// specific AI image on the left and another on the right (desktop). On mobile the text
// is on top and the two images sit below. All text/links stay real HTML — no SEO impact.
export default function ServicesShowcase({ services, lang, hrefFor }) {
  return (
    <div className="mt-8 divide-y divide-white/5">
      {services.map((s, i) => (
        <Reveal key={s.entity_id}>
          <div className="py-14 md:py-24">
            <div className="grid gap-8 lg:grid-cols-[1fr_minmax(300px,440px)_1fr] lg:items-center lg:gap-8 xl:gap-12">
              {/* LEFT image */}
              <div className="order-2 lg:order-1">
                <TiltCard src={serviceAi(s.entity_id)} alt={s.title} dir={-1} />
              </div>

              {/* CENTER text */}
              <div className="order-1 lg:order-2 text-center px-2">
                <span className="inline-flex w-9 h-9 rounded-full border border-white/15 items-center justify-center text-copper text-sm font-bold">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-ink mt-5 leading-[1.05]">
                  {s.title}
                </h3>
                {s.desc && (
                  <p className="text-subtle text-base mt-4 max-w-md mx-auto leading-relaxed">{s.desc}</p>
                )}
                <Link to={hrefFor(s.slug)} data-testid={`service-card-${s.entity_id}`} className="btn-copper mt-7 inline-flex">
                  {t(lang, "getQuote")} <ArrowUpRight size={16} />
                </Link>
              </div>

              {/* RIGHT image */}
              <div className="order-3 lg:order-3">
                <TiltCard src={serviceAi2(s.entity_id)} alt={s.title} dir={1} />
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
